/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.0
 */

import * as Yup from 'yup';

import { ENotificationsSettingsFields } from '@/main/modules/userNotifications/constants';

export const getNotificationsSettingsValidationSchema = (isAssistant: boolean) => {
    const baseValidationSchema = Yup.object().shape({
        [ENotificationsSettingsFields.showNotifications]: Yup.boolean(),
        [ENotificationsSettingsFields.showNews]: Yup.boolean(),
        [ENotificationsSettingsFields.showNotificationsOrders]: Yup.boolean(),
    });

    if (isAssistant) return baseValidationSchema;

    return baseValidationSchema.concat(
        Yup.object({
            [ENotificationsSettingsFields.showNotificationsInquiries]: Yup.boolean(),
            [ENotificationsSettingsFields.showNotificationsEdo]: Yup.boolean(),
            [ENotificationsSettingsFields.showNotificationsCashback]: Yup.boolean(),
        }),
    );
};
